module.exports = __webpack_public_path__ + "static/media/galerija_2021 (33)-min.798063ae.jpg";